var constants = {
  ORGANIZATION: 'organization',
  VENUE: 'venue'
};

module.exports = Object.freeze(constants);
